import React from "react";
import Form, { SimpleItem, Label, GroupItem } from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import uiInfo from "../../ui-info";
import notify from "devextreme/ui/notify";
import Memoria from "../../Memoria";
import {
  criarCalculoManualDiatDs,
  inserirOuAtualizar,
} from "../../DataSources";
import UserInfo from "../../UserInfo";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import AcompanhamentoDiatBox from "../AcompanhamentoDiatBox";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  data: undefined,
  principal: undefined,
  multa: undefined,
  juros: undefined,
  correcao: undefined,
  prefeituraId: undefined,
  popupServicoVisivel: false,
};

export default class CalculoManualDiatForm extends React.Component {
  constructor() {
    super();
    template.prefeituraId = UserInfo.getPrefeitura();
    this.state = {
      ...(_cadastroCorrente || template),
      dividaId: "",
      _uiDivida: "",
    };
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.calculoManualDiatDs = criarCalculoManualDiatDs();
    this.pesquisarDivida = this.pesquisarDivida.bind(this);
    this.setDividaId = this.setDividaId.bind(this);
    this.acompanhamentoDiatBoxRef = React.createRef();

    this.renderDivida = sysCodigoDescricao(
      () => this.state.dividaId.toString(),
      this.setDividaId,
      () => this.state._uiDivida.toString(),
      this.pesquisarDivida
    );
  }

  pesquisarDivida(e) {
    this.setState({ popupDividaVisivel: true });
  }

  setDividaId(data) {
    this.setState({ dividaId: data.value });
    this.updateGrid(data.value, null);
  }

  onDividaSelecionada = (e, entidadeDireta) => {
    let divida = entidadeDireta;

    if (divida == undefined && e && e.row && e.row.data) {
      divida = e.row.data;
    }

    this.setState({
      ...this.state,
      divida,
      dividaId: divida.codigoInterno,
      _uiDivida: divida.seqContribuinte,
      popupDividaVisivel: false,
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={9}>
              <GroupItem caption="Novo cadastro" colSpan={9} colCount={9}>
                <SimpleItem
                  dataField={"data"}
                  editorType="dxDateBox"
                  colSpan={2}
                  editorOptions={{
                    displayFormat: "dd/MM/yyyy",
                    width: "'100%'",
                  }}
                />
                <SimpleItem
                  dataField={"divida"}
                  colSpan={7}
                  component={this.renderDivida}
                >
                  <Label text="Dívida" />
                </SimpleItem>
                <SimpleItem
                  dataField={"multa"}
                  editorType={"dxNumberBox"}
                  colSpan={3}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                />
                <SimpleItem
                  dataField={"juros"}
                  editorType={"dxNumberBox"}
                  colSpan={3}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                />
                <SimpleItem
                  dataField={"correcao"}
                  editorType={"dxNumberBox"}
                  colSpan={3}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Correção" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <br />
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupDividaVisivel}
            onHiding={() => this.setState({ popupDividaVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Serviço"
          >
            <ScrollView showScrollbar={"always"}>
              <AcompanhamentoDiatBox
                onSelecionado={this.onDividaSelecionada}
                ref={this.acompanhamentoDiatBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupServicoVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = {
      data: this.state.data.toISOString(),
      dividaId: this.state.dividaId,
      juros: this.state.juros,
      multa: this.state.multa,
      correcao: this.state.correcao,
      prefeituraId: this.state.prefeituraId,
    };

    inserirOuAtualizar(this.calculoManualDiatDs, entidade)
      .then(
        function () {
          notify(
            "Cálculo Manual de Dívida Ativa cadastrado com sucesso.",
            "success"
          );
          _cadastroCorrente = undefined;
          _cancelando = true;
          Memoria.removerEdicao(this.props.location);
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
